module.exports = __webpack_public_path__ + "static/media/background.88b0ce7b.png";